// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__xcCt5","topLabel":"styles_topLabel__mV7tr","topLabelVal":"styles_topLabelVal__UcUhV","tableContainer":"styles_tableContainer__YLOmI"};